import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoresMainComponent } from './stores-main/stores-main.component';
import { MyStoresListComponent } from './my-stores-list/my-stores-list.component';

const routes: Routes = [
  {
    path: 'main/detail/:id',
    component: StoresMainComponent
  },
  {
    path: 'main',
    component: StoresMainComponent
  },{
    path: 'my-stores/detail/:id',
    component: MyStoresListComponent
  },{
    path: 'my-stores',
    component: MyStoresListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoresRoutingModule { }
